
import Translate from "../../../assets/outline/Translate.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TranslateIcon({ className, dataTestid = "TranslateIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Translate data-testid={dataTestid} className={classes} {...rest} />
  );
}
